var _path, _path2, _path3, _line, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78125 5.2399C7.78125 4.56822 8.32576 4.02371 8.99744 4.02371H16.5651C17.2367 4.02371 17.7813 4.56822 17.7813 5.2399V12.4018C17.7813 15.1632 15.5427 17.4018 12.7813 17.4018V17.4018C10.0198 17.4018 7.78125 15.1632 7.78125 12.4018V5.2399Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7812 4.60318H20.2813C20.5574 4.60318 20.7812 4.82702 20.7812 5.10314V10.6025C20.7812 12.2594 19.4381 13.6025 17.7812 13.6025V13.6025",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78125 4.60318H5.28121C5.00509 4.60318 4.78125 4.82702 4.78125 5.10314V10.6025C4.78125 12.2594 6.1244 13.6025 7.78125 13.6025V13.6025",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.7275,
    y1: 17.4018,
    x2: 12.7275,
    y2: 19.9763,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29199 19.9763H16.2697",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/活动管理.61d6392e17c81f1335e1c6c1df1586a0.svg";
export { ForwardRef as ReactComponent };